export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11219.7e05763b.jpg";